import { CharmInfo, getCharmForKeyword } from 'owa-calendar-charms-store';

/**
 * Checks if they subject contains a keyword
 *  @param subject the subject to ckeck for keywords
 *  @returns either the charm mapping to the keyword or null
 */
export default function checkForKeywords(subject: string) {
    let words = subject.split(' ');
    let i = 0;
    let len = Object.keys(words).length;
    while (i < len) {
        let word = words[i];
        let charm = getCharmForKeyword(word) as CharmInfo;
        if (charm != null) {
            return charm;
        } else {
            i = i + 1;
        }
    }
    return null;
}
